import React from 'react';
import Pageheader from '../utils/headerHelment';
import WorkspaceSetupWizard from '../components/WorkspaceSetup/WorkspaceSetupWizard';

const WorkspaceSetupPage = () => {
    return (
        <>
            <Pageheader title="LENS - Workspace setup" />
            <WorkspaceSetupWizard />
        </>
    );
};

export default WorkspaceSetupPage;
